import * as React from "react";
import { Modal } from "../../../ui/components/Modal";
import { Text } from "../../../ui/components/Text";
import { Button } from "../../../ui/components/Button";
import { useI18n } from "../../lib/i18n";
import * as styles from "./JsonInspectorModal.css";

export function JsonInspectorModal({
  open,
  setOpen,
  title,
  value,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  value: unknown;
}) {
  const { t } = useI18n();
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      minWidth="480px"
      maxWidth="720px"
      minHeight="auto"
      maxHeight="90vh"
      closeOnClickOff
    >
      <Modal.Header>
        <Text level="h3" weight="bold">
          {title}
        </Text>
      </Modal.Header>
      <Modal.Body>
        <pre className={styles.jsonPre}>{JSON.stringify(value, null, 2)}</pre>
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: "flex-end" }}>
        <Button
          color="neutral"
          variant="outline"
          size="md"
          onClick={() => setOpen(false)}
        >
          {t("shared.common.cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
